import { createInjectionKey as o } from "./ghl-ui.es896.js";
const n = o("n-notification-provider");
export {
  n as notificationProviderInjectionKey
};
